import React from 'react';
import css from './index.css';
import {Box,Grid, Card, CardActions,CardContent, List,ListItem, Icon} from '@material-ui/core';
import  {Star} from "@material-ui/icons";
import {useTranslation} from 'react-i18next';

export default function Projects() {
    
    const {t,i18n}=useTranslation();
    
    return (
        <Box>
        <Grid item xs={12}>
        <Grid container justify="center">
        <List>
        <ListItem>
        <Card style={{ width:"100%" }}>
        <CardActions>
        <CardContent>
        <List component="nav">
        <ListItem><strong>  <Icon><Star/></Icon> Fichier Médical</strong></ListItem>
        <ListItem>
        {t('project1.label')}
       <br/>
        URL : https://fichiemedical.herokuapp.com/
       </ListItem>
        </List>
        </CardContent>
        </CardActions>
        </Card>
        </ListItem>
        <ListItem>
        <Card style={{ width:"100%" }}>
        <CardActions>
        <CardContent>
        <List component="nav">
        <ListItem><strong><Icon><Star/></Icon> Rooms</strong></ListItem>
        <ListItem>
        {t('project2.label')}
       <br/>
       URL : https://redroomsapp.herokuapp.com/
       </ListItem>
        </List>
        </CardContent>
        </CardActions>
        </Card>
        </ListItem>
        <ListItem>
        <Card style={{ width:"100%" }}>
        <CardActions>
        <CardContent>
        <List component="nav">
        <ListItem><strong><Icon><Star/></Icon> Tawaaiya</strong></ListItem>
        <ListItem>
        {t('project3.label')}
        <br/>
        URL :https://play.google.com/store/apps/details?id=com.sensibilisationapp.com
        </ListItem>
        </List>
        </CardContent>
        </CardActions>
        </Card>
        </ListItem>
        <ListItem>
        <Card style={{ width:"100%" }}>
        <CardActions>
        <CardContent>
        <List component="nav">
        <ListItem><strong><Icon><Star/></Icon> Blog website</strong></ListItem>
        <ListItem>
        {t('project4.label')}   
        <br/>
        URL :
        <br/>
            front-end on github :  https://github.com/azizmobarak/getintohome.store-blog <br/>
            backend on github:  https://github.com/azizmobarak/scrap-commerce-blogs
       </ListItem>
        </List>
        </CardContent>
        </CardActions>
        </Card>
        </ListItem>
        </List>
        </Grid>
        </Grid>
        </Box>
    );
}